import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ICbicVisiters } from 'app/entities/cbic-visiters/cbic-visiters.model';
import { CbicVisitersService } from 'app/entities/cbic-visiters/service/cbic-visiters.service';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'cbic-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  color:any;
  visiterCount?: any;
  flag:any;
  usefulUrlList?: ICbicContentMst[];
  footerImgList?: ICbicContentMst[];
  visiterCountList?: ICbicVisiters[];
  websitePolicyList?: ICbicContentMst[];
  contactUsList?:ICbicContentMst[];
  constructor(private sessionStorageService: SessionStorageService,private changeLnService: ChangeLanguageService,private contentMstService : CbicContentMstService,private contentVisiter : CbicVisitersService)  {
    this.color = this.sessionStorageService.retrieve('colr');
   
  } 

  ngOnInit(): void {
   
    this.getUsefulUrlData();
    this.getfooterImgData();
    this.getVisiterCount();
    this.getWebsitePolicy();
    this.getcontactus();
  }

  getUsefulUrlData() :void{
    this.contentMstService.getContentData('Useful-link').subscribe(
      (res : HttpResponse<ICbicContentMst[]>) => {
        if(res.body){
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
          this.usefulUrlList = res.body;
        }
      }
    )
    
}

getfooterImgData() :void{
  this.contentMstService.getContentData('Goverment-offical-link').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.footerImgList = res.body;
      }
    }
  )
  
}

getWebsitePolicy() :void{
  this.contentMstService.getContentData('Website-policy').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.websitePolicyList = res.body;
      }
    }
  )
}

getcontactus() :void{
  this.contentMstService.getContentData('Contact-taxpayer').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
        if (usedLanguage === 'hi') {
          this.flag = 'Hi';
        } else {
          this.flag = 'En';
        }
        this.contactUsList = res.body;
      }
    }
  )
}


getVisiterCount() :void{
  this.contentVisiter.getContent().subscribe(
    (res : HttpResponse<ICbicVisiters[]>) => {
      if(res.body){
         const usedLanguage = this.changeLnService.getLanguage();
         let myInt;
         if(usedLanguage === 'hi'){
          myInt =  res.body[0].visiterCountHi ;
         }else{
          myInt =  res.body[0].visiterCountEn ;
         }

        const myFunc = (num: string) => Number(num);
        this.visiterCount = myInt // Array.from(String(myInt), myFunc);
        this.visiterCountList = res.body;
      }
    }
  )}


}
